import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { Button } from '@nearst/ui';

import { OverviewCard } from '../OverviewCard';

import styles from './JourneyCard.module.scss';

/**
 * Titled card wrapper used by the Lovable-design Overview row 2 (Channels,
 * Local Ads, Orders). Matches Lovable's `JourneyCard`: title + optional
 * subtitle + child slot, with a full-width outline-style CTA at the bottom.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {string} props.ctaLabel
 * @param {string} props.ctaHref
 * @param {React.ReactNode} props.children
 */
export const JourneyCard = ({ title, subtitle, ctaLabel, ctaHref, children }) => (
	<OverviewCard>
		<h2 className={styles.title}>{title}</h2>
		{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
		<div className={styles.body}>{children}</div>
		<div className={styles.footer}>
			<Button as={Link} to={ctaHref} className={styles.cta}>
				<span>{ctaLabel}</span>
				<ArrowRightIcon className={styles.arrow} aria-hidden="true" />
			</Button>
		</div>
	</OverviewCard>
);
